/**
 * Hooks to access unified authentication state
 */

import { useContext } from "react";
import { UnifiedAuthContext, type UnifiedAuthContextValue } from "./unified-auth-provider";

/**
 * Hook to access unified authentication state.
 */
export function useUnifiedAuth(): UnifiedAuthContextValue {
  const context = useContext(UnifiedAuthContext);
  if (!context) {
    throw new Error("useUnifiedAuth must be used within an UnifiedAuthProvider");
  }
  return context;
}

/**
 * Hook to get current user ID regardless of auth method.
 */
export function useUserId(): string | null {
  const context = useContext(UnifiedAuthContext);
  return context?.userId ?? null;
}

/**
 * Hook to check if user can trade.
 */
export function useCanTrade(): boolean {
  const context = useContext(UnifiedAuthContext);
  return context?.canTrade ?? false;
}

